<table>
  <thead>
  <!--  <li style="padding-left: 10px;">-->
  <!--    CONTATOS:-->
  <!--  </li>-->
  <th>
    <span (click)="close()" class="material-icons">close</span>
  </th>
  </thead>

  <tbody>
  <ol>
    <a href="assets/files/curriculo-pt.pdf" target="_blank">
      <span class="iconify" data-icon="feather:download"></span>
    </a>
  </ol>
  <ol>
    <a href="https://resume.io/r/teuJcm9Rk" target="_blank">
      <span class="iconify" data-icon="mdi:web"></span>    </a>
  </ol>
  </tbody>
</table>
